module.exports = __webpack_public_path__ + "static/media/innodeu_ipad.4561e575.png";